import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

import { apiConfig } from "../api/api";
import { useNavigate, useLocation } from "react-router-dom";
import { paddleCheckout } from "../../utils/paddleCheckout";

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const Payment = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const txn = query.get("_ptxn") || query.get("txn");

  useEffect(() => {
    if (txn && txn.length > 0) {
      paddleCheckout({
        transactionId: txn,
        isSandbox: apiConfig.isSandbox,
        onComplete: (event) => {
          // handleRegisterFormRequest({
          //   ...values,
          //   preferredLang: "en",
          //   subscriptionType: sType.marketing_platform,
          //   customer: event.data.customer.id,
          //   isSandbox,
          // });
        },
      });
    } else {
      navigate("/dashboard");
    }
  }, []);

  return <div></div>;
};
